export const getReports = state => state.reportsSelector.reports.nodes;
export const getCheckedReports = state => state.reportsSelector.reports.checkedReports;

export const getSelectedReports = state =>
  (state.reportsSelector.reports.nodes || []).filter(node =>
    getCheckedReports(state).includes(node.value));

export const getCheckedReportsLabels = state =>
  getSelectedReports(state).map(node => node.label);
